export const EVENT_TYPE = {
  ACTION: 'action',
  STATE: 'state',
}
